/**
 * Validacao basica de arquivo local antes do parse.
 * Nao acessa rede. Nao persiste dados.
 */
import type { ValidationIssue } from '../validation/validation.types';
import type { LocalInputFile } from './file.types';

const MAX_FILE_BYTES = 50 * 1024 * 1024; // 50MB

export function validateLocalFileBasics(file: LocalInputFile): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  if (!file.text || file.text.trim() === '') {
    issues.push({
      severity: 'error',
      code: 'EMPTY_FILE',
      message: 'O arquivo está vazio.',
      source: 'file-basics',
    });
  }
  if (file.sizeBytes > MAX_FILE_BYTES) {
    issues.push({
      severity: 'error',
      code: 'FILE_TOO_LARGE',
      message: 'O arquivo excede o limite de 50 MB.',
      source: 'file-basics',
    });
  }
  if (file.kind === 'unknown') {
    issues.push({
      severity: 'warning',
      code: 'UNKNOWN_FILE_KIND',
      message: 'Tipo de arquivo não reconhecido. Verifique se é AFD, AEJ ou CSV complementar.',
      source: 'file-basics',
    });
  }
  return issues;
}
